var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 70C15.6695 70 0 54.3305 0 35C0 15.6695 15.6695 0 35 0C54.3305 0 70 15.6695 70 35C70 54.3305 54.3305 70 35 70ZM35 63C42.4261 63 49.548 60.05 54.799 54.799C60.05 49.548 63 42.4261 63 35C63 27.5739 60.05 20.452 54.799 15.201C49.548 9.94999 42.4261 7 35 7C27.5739 7 20.452 9.94999 15.201 15.201C9.94999 20.452 7 27.5739 7 35C7 42.4261 9.94999 49.548 15.201 54.799C20.452 60.05 27.5739 63 35 63ZM31.5 17.5H38.5V24.5H31.5V17.5ZM31.5 31.5H38.5V52.5H31.5V31.5Z",
    fill: "#1c4784"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.6a7257fc01ddcec059e0d77395ec5e9b.svg";
export { ForwardRef as ReactComponent };